/* eslint-disable no-console */
import { Button } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import {
  PlaidLinkOnEvent,
  PlaidLinkOnExit,
  PlaidLinkOnSuccess,
  PlaidLinkOptions,
  usePlaidLink,
} from 'react-plaid-link';

import { getPlaidLinkToken } from '../../../services/bank.service';

const PlaidLinkWithOAuth = () => {
  const [token, setToken] = useState<string | null>(null);
  const isOAuthRedirect = window.location.href.includes('?oauth_state_id=');

  useEffect(() => {
    if (isOAuthRedirect) {
      setToken(localStorage.getItem('link_token'));
      return;
    }
    const createLinkToken = async () => {
      const res = await getPlaidLinkToken().catch((e) => {
        console.log('ERROR FETCHING PLAID LINK TOKEN:', e);
      });

      setToken(res.linkToken);
      localStorage.setItem('link_token', res.linkToken);
    };

    createLinkToken();
  }, []);

  const onSuccess = useCallback<PlaidLinkOnSuccess>((publicToken, metadata) => {
    console.log(
      'onSuccess callBack (publicToken, metadata)',
      publicToken,
      metadata
    );
  }, []);

  const onEvent = useCallback<PlaidLinkOnEvent>((eventName, metadata) => {
    console.log(
      'onEvent callBack (eventName, metadata): ',
      eventName,
      metadata
    );
  }, []);

  const onExit = useCallback<PlaidLinkOnExit>((error, metadata) => {
    console.log('onExit callBanck (error, metadata): ', error, metadata);
  }, []);

  const config: PlaidLinkOptions = {
    token,
    onSuccess,
    onEvent,
    onExit,
  };

  if (isOAuthRedirect) {
    config.receivedRedirectUri = window.location.href;
  }

  const {
    open,
    ready,
    error,
    // exit
  } = usePlaidLink(config);

  useEffect(() => {
    if (isOAuthRedirect && ready) {
      open();
    }
  }, [ready, open, isOAuthRedirect]);

  useEffect(() => {
    console.log('ERROR: usePlaidLink: ', error);
  }, [error]);

  return isOAuthRedirect ? (
    <>Redirected back, execute next</>
  ) : (
    <Button onClick={() => open()} disabled={!ready}>
      Connect a bank account
    </Button>
  );
};

export default PlaidLinkWithOAuth;
